<avi-confirmation
    class="delete-vs-dialog clr-wrapper"
    headerText="{{ l10nKeys.deleteVirtualServiceHeader | vtranslate }}"
    (onClose)="handleClose()"
    size="md"
>
    <ng-container ngProjectAs="avi-confirmation_modal-content">
        <div>{{ l10nKeys.deleteConfirmMessage | vtranslate }}</div>
        <form>
            <avi-radio-container [noMarginTop]="true">
                <avi-radio
                    [value]="false"
                    [(ngModel)]="deleteReferencedObjects"
                    name="delete-referenced-objects"
                    class="sel-delete-vs-only"
                >
                    {{ l10nKeys.deleteVsOnlyLabel | vtranslate }}
                </avi-radio>
                <avi-radio
                    [value]="true"
                    [(ngModel)]="deleteReferencedObjects"
                    name="delete-referenced-objects"
                    class="sel-delete-vs-and-others"
                >
                    {{ l10nKeys.deleteVsObjectsLabel | vtranslate }}
                </avi-radio>
            </avi-radio-container>
        </form>
    </ng-container>
    <ng-container ngProjectAs="avi-confirmation_modal-actions">
        <cds-button
            action="outline"
            (click)="handleClose()"
        >
            {{ globalL10nKeys.closeLabel | vtranslate }}
        </cds-button>
        <cds-button
            status="danger"
            (click)="handleDelete()"
        >
            {{ globalL10nKeys.deleteLabel | vtranslate }}
        </cds-button>
    </ng-container>
</avi-confirmation>
